import { Component, Input, OnInit } from '@angular/core';
import { TimeUnit } from "@models/enums/time-unit.enum";
import { RevisionInfo } from "@components/revision-info/models/revision-info.model";
import { RevisionRecurrence } from "@components/revision-info/models/revision-recurrence.model";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { RevisionUtils } from "@app/shared/util/revision.utils";
import { ValueUnit } from "@models/enums/value-unit.enum";

@Component({
    selector: 'app-revision-info',
    templateUrl: './revision-info.component.html',
    styleUrls: ['./revision-info.component.scss']
})
export class RevisionInfoComponent implements OnInit {

    @Input() operations: any[];
    @Input() revisionInfo: RevisionInfo;

    unit = TimeUnit.MINUTES;

    formGroup: FormGroup;

    public readonly ValueUnit = ValueUnit;
    public readonly RevisionUtils = RevisionUtils;

    private static computeRecurrenceValue(planType: ValueUnit, value: number, unit: TimeUnit) {
        return RevisionUtils.computeRevisionTime(planType, value, unit);
    }

    constructor(private translate: TranslateService,
                private formBuilder: FormBuilder) {
        this.formGroup = this.formBuilder.group({
            'minutes': [''],
            'hours': [''],
            'days': [''],
            'weeks': [''],
            'months': ['']
        });
    }

    ngOnInit() {
    }

    onSelectUnit(value: TimeUnit) {
        this.unit = value;
    }

    computeRecurrenceLabel(recurrence: RevisionRecurrence) {
        const productionSinceLastRevisionLabel = this.translate.instant(
            'admin.toolMaintenancePlans.revisionInfo.productionSinceLastRevision'
        );
        const plannedRevisionLabel = this.translate.instant("admin.toolMaintenancePlans.revisionInfo.plannedRevision");
        const usageLabel = this.translate.instant('admin.toolMaintenancePlans.revisionInfo.usage');
        const recurrenceUnit = this.computeRecurrenceUnit();

        return recurrence.name + ' - ' +
            productionSinceLastRevisionLabel + ': ' +
            RevisionInfoComponent.computeRecurrenceValue(this.revisionInfo.planType,
                recurrence.productionValueSincePlannedValueComputed, this.unit) +
            (recurrenceUnit ? ' ' + recurrenceUnit : '') + ' | ' +
            plannedRevisionLabel + ': ' +
            RevisionInfoComponent.computeRecurrenceValue(this.revisionInfo.planType, recurrence.plannedValue, this.unit) +
            (recurrenceUnit ? ' ' + recurrenceUnit : '') + ' | ' +
            usageLabel + ': ' +
            recurrence.percentage + '%';
    }

    computeRecurrenceUnit() {
        return this.revisionInfo.planType === ValueUnit.Time
            ? this.translate.instant("timeUnits." + this.unit)
            : this.translate.instant('admin.toolMaintenancePlans.revisionInfo.cycles');
    }

}
